export { default as IntlService } from './services/intl-service';
export { default as TemplateService } from './services/template-service';
